const carouselItems = [
  {
    title: '暑期档热剧大盘点',
    desc: '精选红桃视频、樱桃视频七月最热剧集，古装仙侠、都市甜宠、悬疑探案一应俱全',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20aesthetic%20with%20flowing%20hanfu%20robes%20in%20misty%20mountain%20landscape%2C%20ethereal%20lighting%2C%20soft%20pastel%20colors%2C%20cinematic%20widescreen%20composition%2C%20dramatic%20clouds%20and%20flying%20swords&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '高分悬疑烧脑合集',
    desc: '茄子视频口碑悬疑片单，反转不断的剧情让你欲罢不能，每部都是9分以上神作',
    tag: '口碑推荐',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20atmosphere%20with%20rain%20on%20city%20window%2C%20neon%20sign%20reflections%2C%20film%20noir%20style%2C%20deep%20blue%20and%20amber%20tones%2C%20silhouette%20figure%20in%20trench%20coat%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国产动画崛起专区',
    desc: '糖心视频独家动画频道，收录年度最美国风动画电影与番剧，每一帧都是壁纸',
    tag: '国创专区',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20style%20landscape%20with%20ink%20wash%20painting%20aesthetic%2C%20traditional%20architecture%20in%20misty%20mountains%2C%20cherry%20blossom%20petals%2C%20golden%20hour%20lighting%2C%20poetic%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '爆笑喜剧放松必备',
    desc: '忙碌一天后最好的解压方式，红桃视频爆笑片库让你笑到停不下来',
    tag: '轻松一刻',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20large%20TV%20screen%2C%20soft%20ambient%20lighting%2C%20comfortable%20sofa%20with%20blankets%2C%20popcorn%20bowl%2C%20evening%20vibe%2C%20home%20theater%20atmosphere%2C%20golden%20warm%20tones&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '经典港片修复重映',
    desc: '樱桃视频4K修复经典港片系列，重温黄金年代的光影记忆',
    tag: '经典重温',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20aesthetic%20with%20old%20movie%20posters%20on%20brick%20wall%2C%20vintage%20neon%20signs%2C%20warm%20tungsten%20lighting%2C%20nostalgic%201980s%20atmosphere%2C%20film%20projector%20vibe&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '纪录片深度探索',
    desc: '茄子视频纪录片频道，自然人文历史科技，打开你的认知新世界',
    tag: '知识频道',
    img: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20vast%20natural%20landscape%20with%20dramatic%20clouds%2C%20golden%20sunlight%20breaking%20through%2C%20documentary%20film%20aesthetic%2C%20epic%20scale%2C%20warm%20earth%20tones%2C%20cinematic%20composition&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          热门专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          精选优质内容专题，发现你的下一部心头好
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-500 font-medium cursor-pointer">
                  查看专题
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}